// Kept in its own module so product.ts can import it without a
// deal.ts <-> product.ts cycle (deal.ts imports PaymentOption from product.ts).
export enum DealCategory {
  AirlineMiles = "Airline Miles",
  HotelPoints = "Hotel Points",
  CreditCardPoints = "Credit Card Points",
  Disqualified = "Disqualified",
}
